module.exports = __webpack_public_path__ + "static/5cb50d60d54082c5051f7c8d996fb41d.png";